const Routing = {
    Index: "/",
    AlternativeFrontPages: {
        Tilbud: "/tilbud",
        FibiaFiber: "/fibia-fiber",
        Fibia: "/fibia",
        Ida: "/ida",
        TjekBredbaand: "/tjekbredbaand",
        TDCPaid: "/tdcnet",
    },
    Order: "/bestil",
    LargeAccountOrder: "/bestil/storkunde",
    Contact: {
        Index: "/kontakt",
        Form: "/kontaktformular",
        InternetNotWorking: "/kontakt/internet-virker-ikke",
        InternetUnstable: "/kontakt/ustabilt-internet",
        RouterSetup: "/kontakt/opsaetning-af-router",
        EquipmentReturn: "/kontakt/returnering-af-udstyr",
        BillAndPaymentCard: "/kontakt/regning-og-betalingskort",
        Subscription: "/kontakt/abonnement",
        DeliveryTime: "/kontakt/leveringstid",
        Order: "/kontakt/bestil-internet",
    },
    Broadband: {
        Index: "/bredbaand",
        CoverageMap: "/bredbaand/daekningskort",
        Coax: "/bredbaand/kabel-tv-stik",
        Fiber: "/bredbaand/fibernet",
        TDC5G: "/bredbaand/5g-internet",
        MBB: "/bredbaand/mobilt-bredbaand",
        Mesh: "/bredbaand/wifi-mesh",
    },
    About: {
        Index: "/om-hiper",
        Trustpilot: "/trustpilot",
        Jobs: "/ledige-jobs",
        Conditions: "/aftalevilkaar",
        CustomerSatisfaction: "/kundetilfredshed",
        Press: "/presse",
    },
    Help: {
        Index: "/hjaelp",
    },
    Selfcare: {
        Index: "/mit-hiper",
        Login: "/mit-hiper/login",
        LoginCreate: "/mit-hiper/login/opret",
        LoginCode: "/mit-hiper/login/kode",
        Internet: "/mit-hiper/internet",
        Bills: "/mit-hiper/regninger",
        NextBill: "/mit-hiper/regninger/kommende-regning",
        PayBill: "/mit-hiper/regninger/betal-regning",
        Account: "/mit-hiper/oplysninger",
        Letters: "/mit-hiper/breve",
        Card: "/mit-hiper/kort",
        AddCard: "/mit-hiper/kort/tilfoej",
        TerminateExisting: "/mit-hiper/opsig-nuvaerende-udbyder",
        TerminateExistingReceipt: "/mit-hiper/opsig-nuvaerende-udbyder/gem/kvittering",
    }
}

export default Routing
